import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 p-2 bg-white dark:border-gray-800 rounded-md shadow-md"
}
const _hoisted_2 = { class: "grid gap-2 grid-cols-2" }

import EditInputCustom from '@/components/components/editInputCustom.vue';
  import { computed, onMounted, ref } from 'vue';
  import { additionalCosts, carData } from '@/types';
  import moment from 'moment';
  import { getSession } from '@/indexedDB';
  // const injectedDataCar = inject<carData>('dataCar');
  // const additionalFields = inject<additionalCosts>('additionalFields');
  //
  // const dataCar = ref<carData>(injectedDataCar || {});
  //
  // if (injectedDataCar) {
  //   watch(
  //     () => injectedDataCar,
  //     (newVal) => {
  //       dataCar.value = newVal;
  //     },
  //     { immediate: true, deep: true }
  //   );
  // }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'TotalCalcBlock',
  setup(__props) {

  const fields = {
    poland: [
      {
        id: 'expeditionCost',
        model: 'expeditionCost',
        title: 'Transport to Poland ($)',
        tooltip:
          '*the final price depends on the situation at the border and the cost of propellants',
      },
      {
        id: 'customsCost',
        model: 'customsCost',
        title: 'Customs fees ($)',
        tooltip: '*Customs clearance cost in ' + moment().year() + '.',
      },
      {
        id: 'rotterdamComplex',
        model: 'certification',
        title: 'Rotterdam Complex ($)',
        tooltip: '*Rotterdam Complex (average cost).',
      },
      {
        id: 'serviceCost',
        model: 'serviceCost',
        title: 'Service fee ($)',
        tooltip: '*Company services',
      },
    ],
    ukraine: [
      {
        id: 'year',
        model: 'expeditionCost',
        title: 'Shipping fees ($)',
        tooltip: '*Expedition, T-1, loading, cash',
      },
      {
        id: 'bid',
        model: 'parkingCost',
        title: 'Parking cost ($)',
        tooltip: '*Estimated parking in Klaipėda',
      },
      {
        id: 'auctionFee',
        model: 'towingCost',
        title: 'Towing service ($)',
        tooltip: '*Tow truck Klaipėda - Lviv.',
      },
      {
        id: 'customsCost',
        model: 'customsCost',
        title: 'Customs fees ($)',
        tooltip: '*Customs clearance cost in ' + moment().year() + '.',
      },
      {
        id: 'certification',
        model: 'certification',
        title: 'Certification cost ($)',
        tooltip: '*Certification (average cost).',
      },
      {
        id: 'pensionCost',
        model: 'pensionCost',
        title: 'Pension fee ($)',
        tooltip: '*Pension fund payment.',
      },
      {
        id: 'serviceCost',
        model: 'serviceCost',
        title: 'Service fee ($)',
        tooltip: '*Company services',
      },
    ],
  };
  const additionalFields = ref<additionalCosts | null>(null);
  const dataCar = ref<carData | null>(null);

  const total = computed(() => {
    const { info, shipping } = dataCar.value;
    return (
      (+info.priceNow || 0) +
      (shipping.shippingByPhoto && shipping.shippingByPhoto[0]
        ? +shipping.costShippingInsurance
        : 0) +
      (+shipping.cost || 0) +
      (+info.auctionFee || 0) +
      (+shipping.bodyPrice || 0) +
      (+shipping.costShippingInsurance || 0) +
      (+additionalFields.value.customsCost || 0) +
      (+additionalFields.value.pensionCost || 0) +
      (+additionalFields.value.certification || 0) +
      (+additionalFields.value.expeditionCost || 0) +
      (+additionalFields.value.parkingCost || 0) +
      (+additionalFields.value.serviceCost || 0) +
      (+additionalFields.value.towingCost || 0)
    ).toFixed(2);
  });

  onMounted(async () => {
    dataCar.value = await getSession('car');
    additionalFields.value = await getSession('additionalFields');
  });

return (_ctx: any,_cache: any) => {
  return (additionalFields.value && dataCar.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields[dataCar.value?.info?.countryCalc], (field) => {
            return (_openBlock(), _createElementBlock("div", {
              key: field.id
            }, [
              _createVNode(EditInputCustom, {
                class: "w-full",
                id: field.id,
                type: "number",
                modelValue: additionalFields.value[field.model],
                "onUpdate:modelValue": ($event: any) => ((additionalFields.value[field.model]) = $event),
                title: field.title,
                "tooltip-text": field.tooltip
              }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "title", "tooltip-text"])
            ]))
          }), 128)),
          _createElementVNode("div", null, [
            _cache[0] || (_cache[0] = _createElementVNode("div", null, "Total :", -1)),
            _createElementVNode("div", null, "$" + _toDisplayString(total.value), 1)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})